//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import Heading from '../../Components/Heading';
import ListGroup from '../../Components/ListGroup';
import ImageBlurFallback from '../../Components/ImageBlurFallback';
import ShortText from '../../Components/ShortText';
import { CLIENT_URL_IMAGE } from '../../config.local';

import { FeedbackData } from '../../GlobalTypes';

type FeedbackProps = {
  feedbacks: Array<FeedbackData>
};

const FeedbackCard = ({ image, title, description, className }) => {
  return (
    <div className={`feedback-card-container ${className}`}>
      <div className="feedback-card-heading">
        <ImageBlurFallback className="feedback-card-img" src={image} />
        <span className="feedback-card-title">{title}</span>
      </div>
      <ShortText text={description} minWords={270}>
        {text => <span className="feedback-card-desc">{text}</span>}
      </ShortText>
    </div>
  );
};
const Feedback = ({ feedbacks }: FeedbackProps) => {
  const { t } = useTranslation();
  return (
    <ListGroup
      containerClassName="home-feedback-container"
      title={<Heading title={t('feedbackHeading')} />}
      count={2}>
      {feedbacks.map((item, index) => {
        return index < 4 ? (
          <FeedbackCard
            image={`${CLIENT_URL_IMAGE}/${item.avatarUrl}`}
            title={item.name}
            // senderDetails={item.collegeName}
            description={item.feedback}
            key={item.id}
          />
        ) : null;
      })}
    </ListGroup>
  );
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/Pages/Home/Feedback.js